import { ref, computed } from 'vue';
export default {
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      required: true
    },
    clsName: {
      type: String,
      require: false
    }
  },
  setup(props) {
    // eslint-disable-next-line
    const {
      text
    } = props;
    return {
      text
    };
  }
};